/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of YesNoField.
 * @typedef {Object} YesNoFieldType
 *
 * @typedef {QuestionFormFieldType & YesNoFieldType} YesNoFieldExtendType
 */

/**
 * Represents a yes no form field.
 * @class
 */
export default class YesNoField extends QuestionFormField {}
